var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerification1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_15967)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9598 2.05997L5.4598 4.11997C4.91501 4.35793 4.44752 4.74335 4.11005 5.23277C3.77258 5.7222 3.57854 6.29617 3.5498 6.88997L3.5498 14.99C3.57475 15.4431 3.69233 15.8863 3.89529 16.2922C4.09824 16.6981 4.38226 17.0581 4.7298 17.35L10.2298 21.46C10.7493 21.8165 11.3647 22.0074 11.9948 22.0074C12.6249 22.0074 13.2403 21.8165 13.7598 21.46L19.2598 17.35C19.6065 17.0574 19.8899 16.6972 20.0928 16.2915C20.2957 15.8857 20.4138 15.4429 20.4398 14.99V6.88997C20.411 6.29745 20.2168 5.72485 19.8792 5.23705C19.5416 4.74924 19.0742 4.36573 18.5298 4.12997L13.0298 2.06997C12.3576 1.85156 11.6341 1.84807 10.9598 2.05997Z",
    fill: "#BBC6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6587 14.232C10.5601 14.2324 10.4625 14.2131 10.3715 14.1753C10.2805 14.1376 10.198 14.082 10.1287 14.012L8.51965 12.399C8.38717 12.2568 8.31505 12.0688 8.31848 11.8745C8.3219 11.6802 8.40062 11.4948 8.53803 11.3574C8.67544 11.22 8.86083 11.1413 9.05513 11.1378C9.24943 11.1344 9.43748 11.2065 9.57965 11.339L10.6597 12.419L14.4297 8.65002C14.5718 8.51754 14.7599 8.44542 14.9542 8.44885C15.1485 8.45228 15.3339 8.53099 15.4713 8.6684C15.6087 8.80581 15.6874 8.9912 15.6908 9.1855C15.6943 9.3798 15.6221 9.56785 15.4897 9.71002L11.1897 14.01C11.1204 14.0805 11.0377 14.1365 10.9466 14.1746C10.8554 14.2127 10.7575 14.2322 10.6587 14.232Z",
    fill: "#BBC6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_15967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification1);
export default __webpack_public_path__ + "static/media/verification 1.d28fe22eed4498a8f3a12102f9e53fcc.svg";
export { ForwardRef as ReactComponent };